import React from "react";
import "./ourclient.css";

import img from "../../assets/logos/Untitled-design-22-1.png";
import img1 from "../../assets/logos/Untitled-design-23-1.png";
import img2 from "../../assets/logos/Untitled-design-24-1.png";
import img3 from "../../assets/logos/Untitled-design-25-1.png";
import img4 from "../../assets/logos/Untitled-design-26-1.png";
import img5 from "../../assets/logos/Untitled-design-28.png";
import img6 from "../../assets/logos/Untitled-design-29.png";
import img7 from "../../assets/logos/Untitled-design-31.png";
import img8 from "../../assets/logos/Untitled-design-33.png";
import img9 from "../../assets/logos/Untitled-design-32.png";
import img10 from "../../assets/logos/Untitled-design-34.png";
import img11 from "../../assets/logos/Untitled-design-35.png";
import img12 from "../../assets/logos/Untitled-design-36.png";
import img13 from "../../assets/logos/Untitled-design-37.png";
import img14 from "../../assets/logos/Untitled-design-38.png";
import img15 from "../../assets/logos/Untitled-design-39.png";
import img16 from "../../assets/logos/Untitled-design-40.png";
import img17 from "../../assets/logos/Untitled-design-41.png";
  import AOS from "aos";
  import "aos/dist/aos.css";
  import { useEffect } from "react";
  


function OurClient() {
  const logos = [
    img, img1, img2, img3, img4, img5,
    img6, img7, img8, img9, img10, img11,
    img12, img13, img14, img15, img16, img17
  ];


  
    
         useEffect(() => {
          AOS.init({
            duration: 1000, // animation duration (1 second)
            once: true,     // animation happens only once
          });
        }, []);

  return (
    <section className="ourclient-section" data-aos = "fade-up">
      <div className="container clients-conteiner">
        <h2 className="client-title"><span className="client-span">Trusted By Clients</span>
&nbsp; Who Believe's In Excellence
</h2>

        <div className="client-grid">
          {logos.map((logo, index) => (
            <div className="client-card" key={index}>
              <img src={logo} alt={`Client ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurClient;
